import React from 'react'

import Access from '../../content/home/footer/access';
import Images from '../Images/Images';
import PhoneRingning from '../svg/commons/phone_ringing';
import DetailLogo from '../../content/model_detail/detail_logo';

export const AccessSection = (props) => {
    const { _model } = props;

    function get_call_section() {
        return (
            <div className="detail_maintenance_header_telcontainer">
                <div className="detail_maintenance_header_telicon">
                    <PhoneRingning></PhoneRingning>
                </div>
                <div className="detail_maintenance_header_info_container">
                    <div className="detail_maintenance_header_info_llamanos">Llámanos:</div>
                    <div className="detail_maintenance_header_info_tel">800 CALOREX (225 67 39) </div>
                </div>
            </div>
        )
    }
    return (
        <div className="access-section">
            <div className="detail_maintenance_header">
                <div className="detail_maintenance_header_right">
                    <DetailLogo _name='' _title="Servicio de Mantenimiento"></DetailLogo>
                    <p className="detail_maintenance_header_description">¿Necesitas un técnico especializado que revise tu Calorex?</p>
                    {get_call_section()}
                </div>
                <div className="detail_maintenance_header_left">
                    <div className="detail_maintenance_header_imagecontainer">
                        <Images
                            sources={{
                                mb: {
                                    url: '/assets/images/model_detail/maintenance/calorex_maintenance_xs.png'
                                },
                                lg: {
                                    url: '/assets/images/model_detail/maintenance/calorex_maintenance_lg.png'
                                },
                                url: '/assets/images/model_detail/maintenance/calorex_maintenance_xlg.png'
                            }}
                            alt="Calorex Mantenimiento"
                        />
                    </div>
                    {get_call_section()}
                </div>
            </div>
            <div className="detail_maintenance_body">
                <div className="detail_maintenance_body_items">
                    <Access _section='maintenance' product_name={_model && _model.data && _model.data.model_name ? _model.data.model_name.text : ''} product_category={_model && _model.data && _model.data.category ? _model.data.category.uid : ''}></Access>
                </div>

            </div>
        </div>
    )
}
